import React from 'react';
import PropTypes from 'prop-types';

import { SELECT_PAYMENT_MODAL_NAME } from './constants';
import { ensureCurrencyIsPresent } from './util';

export default function ProtectionAndSupportContent({
  amountInDollars,
  onOpenModalClick,
  isDogPayment
}) {
  return (
    <div className="ProtectionAndSupportContent">
      <div className="mb6 bb b--lightest-gray">
        <h5 className="f3 f4-md fw-medium col tc pb2 pt1">
          Protection &amp; Support
        </h5>
      </div>
      <div className="container">
        <div className="ph6 ph8-md">
          <div className="row">
            <p className="font-16">
              This covers protection and support on your&nbsp;
              {ensureCurrencyIsPresent(amountInDollars)} purchase, which keeps
              your payment safe and allows our team to step in to mediate any
              issue.
              {isDogPayment &&
                ` You also get access to weekly coaching calls, courses, and more,
            normally valued at $235.`}
            </p>
          </div>

          <div className="row">
            <button
              className="font-16 stone-700 underline"
              type="button"
              onClick={() =>
                onOpenModalClick(SELECT_PAYMENT_MODAL_NAME.LEARN_MORE)
              }
            >
              Learn more
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ProtectionAndSupportContent.propTypes = {
  amountInDollars: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onOpenModalClick: PropTypes.func.isRequired,
  isDogPayment: PropTypes.bool
};

ProtectionAndSupportContent.defaultProps = {
  isDogPayment: false
};
